import classes from "./ERPHome.module.css";
import PergasLogo from "../../../images/logos/pergas/pergas-logo.png";
// import { useState } from "react";
import { useContext, useEffect } from "react";
import AdminAuthContext from "../../../store/adminStore/admin-auth-context";
import { useLocation, useNavigate } from "react-router-dom";
import storePackageAccessResInIndexedDB from "../../../utils/cache/PackageAccess/storePackageAccessResInIndexedDB";
import clearERPStores from "../../../utils/cache/clearERPStores";
import { toast } from "react-toastify";
import useHttpFetch from "../../../hooks/useHttpFetch";

const ERPHome = () => {
  const { isLoading, sendRequest } = useHttpFetch();
  const { setClientAuthInfo, clientAuthInfo } = useContext(AdminAuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  // const [dlImg, setDlImg] = useState("please wait");

  // useEffect(() => {
  //   const sendGetReq = async () => {
  //     const downloadedImg = await sendRequest({
  //       url: `download/LicenseInfo/7196760034366510384`,
  //       // url: "https://servercmit.lafarrerr.com:8084/download/LicenseInfo/7196411765746414556.jpg",
  //       // notEV: true,
  //       noMiddleUrl: true,
  //       isBlob: true,
  //     });
  //     if (downloadedImg.response && downloadedImg.resIsOk)
  //       setDlImg(URL.createObjectURL(downloadedImg.response));
  //   };
  //   sendGetReq();
  // }, []);

  // useEffect(() => {
  //   const getPackageAccessViaApi = async () => {
  //     const verifyReqOptions = {
  //       url: `PackageAccess`,
  //       noMiddleUrl: true,
  //     };

  //     const authRes = await sendRequest(verifyReqOptions);

  //     if (authRes?.resIsOk) {
  //       setClientAuthInfo((ps) => ({
  //         ...ps,
  //         isLoggedIn: true,
  //         accessibilities: authRes.response.packageAccesses,
  //         // userName:
  //         //   authRes.response.firstName || authRes.response.lastName
  //         //     ? `${authRes.response.firstName} ${authRes.response.lastName}`
  //         //     : "Dear Admin",
  //         userId: authRes.response?.userId,
  //         baseUserId: authRes.response?.baseUserId,
  //         userTypeEnum: authRes.response?.userTypeEnum,
  //         organizationalTitles: authRes.response?.organizationalTitles,
  //       }));
  //       if (location.pathname?.includes("login")) navigate("/admin-home-page");
  //       const preferedData = {
  //         isLoggedIn: true,
  //         accessibilities: authRes.response.packageAccesses,
  //         // userName:
  //         //   authRes.response.firstName || authRes.response.lastName
  //         //     ? `${authRes.response.firstName} ${authRes.response.lastName}`
  //         //     : "Dear Admin",
  //         userTypeEnum: authRes.response?.userTypeEnum,
  //         organizationalTitles: authRes.response?.organizationalTitles,
  //         baseUserId: authRes.response?.baseUserId,
  //         userId: authRes.response?.userId,
  //       };
  //       await storePackageAccessResInIndexedDB(preferedData);
  //     } else {
  //       const authResp = await sendRequest({
  //         url: `panel/AccessToken`,
  //         noMiddleUrl: true,
  //         port: "8088",
  //       });
  //       if (authResp.resIsOk) {
  //         const authenticateReqOptions = {
  //           url: "UserAuthenticate?calendar=pe&language=persian",
  //           additionalHeader: { Authorization: `Bearer ${authResp.response.message}` },
  //           noMiddleUrl: true,
  //         };
  //         const authRes = await sendRequest(authenticateReqOptions);
  //         if (authRes.resIsOk) {
  //           setClientAuthInfo((ps) => ({
  //             ...ps,
  //             isLoggedIn: true,
  //             accessibilities: authRes.response.packageAccesses,
  //             // userName:
  //             //   authRes.response.firstName || authRes.response.lastName
  //             //     ? `${authRes.response.firstName} ${authRes.response.lastName}`
  //             //     : "Dear Admin",
  //             userId: authRes.response?.userId,
  //             baseUserId: authRes.response?.baseUserId,
  //             userTypeEnum: authRes.response?.userTypeEnum,
  //             organizationalTitles: authRes.response?.organizationalTitles,
  //           }));
  //           toast.success("logged in successfullys");
  //           if (location.pathname?.includes("login")) navigate("/admin-home-page");
  //           const preferedData = {
  //             isLoggedIn: true,
  //             accessibilities: authRes.response.packageAccesses,
  //             // userName:
  //             //   authRes.response.firstName || authRes.response.lastName
  //             //     ? `${authRes.response.firstName} ${authRes.response.lastName}`
  //             //     : "Dear Admin",
  //             userTypeEnum: authRes.response?.userTypeEnum,
  //             organizationalTitles: authRes.response?.organizationalTitles,
  //             baseUserId: authRes.response?.baseUserId,
  //             userId: authRes.response?.userId,
  //           };
  //           await storePackageAccessResInIndexedDB(preferedData);
  //         } else {
  //           toast.error("error ::: ", authRes);
  //           clearERPStores();
  //           navigate("/admin/login");
  //         }
  //       } else {
  //         clearERPStores();
  //         navigate("/admin/login");
  //       }
  //     }
  //   };

  //   getPackageAccessViaApi();
  // }, []);
  return (
    <div className={classes.container}>
      <h1>Welcome</h1>
      <img src={PergasLogo} alt="Pergas Logo" className={classes.logo} />
      {/*    {isLoading ? (
        "Loading the Image ........."
      ) : (
        <img src={dlImg} alt="DownloadedImg" className={classes.logo} />
      )} */}
    </div>
  );
};

export default ERPHome;
